import React from "react";
import { withRouter } from "react-router";
import { Card } from "antd";
import Helmet from "react-helmet";
import { getCasesByCourt, getCasesByStatus, getCasesByIndustry, getCasesByEntityType } from "../../services/api-maxval";
import { DonutChart, makeWidthFlexible } from "@unifiedpatents/euclid-react";
import { objectToSeries } from "@unifiedpatents/euclid-react/lib/helpers/preprocessors";
import * as Colors from "@unifiedpatents/euclid-react/lib/helpers/colors";
import { withChartData } from "../common/chart-data-hoc";
import { withChartConfig } from "../common/chart-config-hoc";
import { keepOnlyLitigationQueryStrings } from "../../helpers/url";

const styles = {
  fullWidth: {
    width: "100%"
  }
};

const COLOR_MAP_ENTITY_TYPE = {
  "Operating Company": Colors.grey300,
  University: Colors.grey400,
  "Gov/NGO/Non-Profit": Colors.grey500,
  "NPE (Patent Assertion Entity)": Colors.blue400,
  "NPE (Small Company)": Colors.blue300,
  "NPE (Individual)": Colors.blue200
};

const Analytics = props => {
  const helmet = {
    title: "Litgation Analytics",
    meta: [
      {
        name: "keywords",
        content: "Litigation Analytics,litigation stats,litigation by court,litigation by industry"
      },
      {
        name: "description",
        content: "Patent litigation analytics."
      }
    ]
  };
  const q = keepOnlyLitigationQueryStrings(props.location.query);
  const ChartByStatus = withChartConfig(withChartData(makeWidthFlexible(DonutChart), getCasesByStatus, q));
  const ChartByCourt = withChartConfig(withChartData(makeWidthFlexible(DonutChart), getCasesByCourt, q));
  const ChartByIndustry = withChartConfig(withChartData(makeWidthFlexible(DonutChart), getCasesByIndustry, q));
  const ChartByEntityType = withChartConfig(withChartData(makeWidthFlexible(DonutChart), getCasesByEntityType, q));
  return (
    <Card>
      <Helmet {...helmet} />
      <div style={styles.fullWidth}>
        <ChartByStatus title="Cases by Status" colorMap={{ Open: Colors.blue400, Closed: Colors.grey400 }} dataFormatter={objectToSeries} height={400} scrollable={false} />
      </div>
      <div style={styles.fullWidth}>
        <ChartByCourt title="Cases by Court" dataFormatter={objectToSeries} height={400} scrollable={false} />
      </div>
      <div style={styles.fullWidth}>
        <ChartByIndustry title="Cases by Industry" dataFormatter={objectToSeries} height={400} scrollable={false} />
      </div>
      <div style={styles.fullWidth}>
        <ChartByEntityType title="Cases by Entity Type" colorMap={COLOR_MAP_ENTITY_TYPE} dataFormatter={objectToSeries} height={400} scrollable={false} />
      </div>
    </Card>
  );
};

export default withRouter(Analytics);
